import React, { useEffect, useState } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify'; //토스트(toast)
import axios from 'axios';
import moment from 'moment';
// import '../../css/event20240101.css';

const ContentItem19 = (props) => {
  //   console.log(props.childProps);
  const [alram, setAlram] = useState(0);
  const { imgUrl, tveeImgUrl } = props;
  const { contentSerial, img, comment, title, cp, alramFlag, king } =
    props.childProps;

  const _toggleAram = async () => {
    const { loginId, history, apiUrl } = props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      history.push('/login');
    } else {
      const result = await axios.post(`${apiUrl}/alramToggle`, {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      });

      const intReturn = result.data[0].intReturn;
      console.log(intReturn);
      setAlram(intReturn);

      if (intReturn === 100) {
        toast.success(
          '알림 등록 성공~! 모바일 APP을 통해서만 알림을 받으실 수 있습니다.'
        );
      } else {
        toast.warn('알림 해제 성공~!');
      }
    }
  };
  const _goContent = () => {
    const { setContentSerial } = props;
    if (cp === 'aniplus') {
      setContentSerial(contentSerial);
    } else {
      window.open(`https://www.animaxtv.co.kr/content/${contentSerial}`);
    }
  };
  useEffect(() => {
    setAlram(alramFlag);
  }, [contentSerial]);

  return (
    <li className={cp === 'aniplus' ? 'item' : 'item_max'}>
      <div className="thumb">
        <a onClick={_goContent} style={{ cursor: 'pointer' }}>
          <div>
            <img src={img} style={{ width: '100%' }} />
          </div>
        </a>
      </div>
      <div className="info">
        <p className="date">
          <img
            src={
              cp === 'aniplus'
                ? '/img/event/event202604/icon_label01_1.svg'
                : '/img/event/event202604/icon_label01_2.svg'
            }
            alt="본"
          />
          {comment}
        </p>
        <div className="subject">
          <a onClick={_goContent} style={{ cursor: 'pointer' }}>
            {title}
          </a>
          {/* {cp === 'aniplus' && (
            <div className="btn_bottom">
              <a
                className={alram === 0 ? '' : 'on'}
                onClick={_toggleAram}
                style={{ cursor: 'pointer' }}
              >
                {alram === 0 ? '본방알림 받기' : '본방알림 해제'}
              </a>
            </div>
          )} */}
        </div>
      </div>
      {moment(new Date()).format('YYYY-MM-DD hh:mm:ss') >
      '2024-06-23 18:00:00' ? (
        king === 1 ? (
          <div className="top_icon">
            <img src="/img/event/event202604/top_icon.png" />
          </div>
        ) : null
      ) : null}
    </li>
    // <div>
    //   <div>
    //     <div onClick={_goContent}>{title}</div>
    //     <div onClick={_toggleAram}>{alram === 0 ? '알람받기' : '알림해제'}</div>
    //   </div>
    // </div>
  );
};

export default shopContext(withRouter(ContentItem19));
